import React, { useState } from 'react';
import logo from '../../../../assets/images/Logo-no-bg.png';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import './asideNav.css';
import { LuLayoutDashboard } from 'react-icons/lu';
import { IoTicket } from 'react-icons/io5';
import { MdOutlineAddCircleOutline } from 'react-icons/md';
import { MdOutlineCallReceived } from 'react-icons/md';
import { LuPrinter } from 'react-icons/lu';
import { RiLockPasswordLine } from 'react-icons/ri';
import { MdOutlinePayments } from 'react-icons/md';
import { LuScanLine } from 'react-icons/lu';
import GetLocalStorageUserId from '../../../sharedComponents/GetLocalStorageuserId';
import ToggleButton from '../../../sharedComponents/navbar/sub_component/ToggleButton';
import { toast } from 'react-toastify';
const AsideNav = () => {
  // get local storage data.
  const localdata = localStorage.getItem('sundorbonBookingUserDetails');
  const Name = JSON.parse(localdata)?.Name || '';
  const Email = JSON.parse(localdata)?.Email || '';

  // route change handle.

  const NavBarhandle = () => {
    console.log('fired.');
    setToggleBtnChecked(false);
    setShowAside(false);
  };
  const Routes = (
    <>
      <NavLink
        onClick={NavBarhandle}
        end
        className='flex lg:w-full items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'/agent-dashboard'}
      >
        <LuLayoutDashboard />
        Dashboard
      </NavLink>

      <NavLink
        onClick={NavBarhandle}
        className='flex lg:w-full items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'requisition'}
      >
        <MdOutlineAddCircleOutline />
        Requisition
      </NavLink>

      <NavLink
        onClick={NavBarhandle}
        className='flex lg:w-full items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'receive'}
      >
        <MdOutlineCallReceived />
        Receive
      </NavLink>

      <NavLink
        onClick={NavBarhandle}
        className='flex lg:w-full items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'payment'}
      >
        <MdOutlinePayments />
        Payment
      </NavLink>

      <NavLink
        onClick={NavBarhandle}
        className='flex lg:w-full items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'parcel-status-scan'}
      >
        <LuScanLine />
        Parcel Status Scan
      </NavLink>

      {/* <NavLink
          className="flex lg:w-full items-center hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3"
          to={"cash-payment"}
        >
          <MdOutlinePayments />
          Cash Payment
        </NavLink> */}

      {/* <NavLink
          className="flex lg:w-full items-center hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3"
          to={"change-password"}
        >
          <RiLockPasswordLine />
          Change Password
        </NavLink> */}

      <NavLink
        onClick={NavBarhandle}
        className='flex lg:w-full items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'print-barcode'}
      >
        <LuPrinter />
        Print Barcode
      </NavLink>

      <Link
        className='flex lg:w-full items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'/agency-bookings'}
      >
        <IoTicket />
        Add Booking
      </Link>
    </>
  );

  const [showAside, setShowAside] = useState(false);
  const [toggleBtnChecked, setToggleBtnChecked] = useState(false);
  const ToggleEventHandler = (e) => {
    e.stopPropagation();
    setShowAside(e.target.checked);
    setToggleBtnChecked(e.target.checked);
  };

  const move = useNavigate();
  const logoutHandle = () => {
    toast.success('Logout Successfull', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    });
    localStorage.removeItem('sundorbonBookingUserDetails');
    localStorage.removeItem('token');
    move('/');
  };

  return (
    <div className='xl:w-[17%] lg:w-[25%] lg:flex z-30 flex-col justify-start items-start lg:gap-12 lg:pb-11 overflow-hidden lg:pt-11 w-full lg:h-[93vh] lg:rounded-[25px] lg:sticky top-0 lg:top-[3%] lg:left-2 xl:left-5 bg-black text-white lg:bg-[#b4b4b4]'>
      {/* top image and profile text info. */}
      <div className='relative hidden lg:w-full lg:flex justify-center items-center flex-row lg:flex-col'>
        <img
          // className="w-full px-3 object-contain  lg:inline-block hidden xl:h-[142px] lg:h-[100px]"
          className='w-full max-w-[200px]  object-contain mx-auto px-3 lg:inline-block hidden xl:h-[142px] lg:h-[100px]'
          src={logo}
          alt='logo'
        />
        <div className='lg:mt-[54px] text-center hidden lg:block'>
          <h1 className='text-xl font-semibold '>{Name}</h1>
          <h1 className='text-base font-semibold mt-1'>{Email}</h1>
        </div>
      </div>
      {/* aside nav bar */}
      <ul className='lg:text-white lg:w-full  overflow-y-auto hidden  lg:text-[18px] lg:px-4 lg:flex items-end lg:items-center  justify-start lg:justify-start lg:flex-col  lg:gap-y-1'>
        {Routes}
      </ul>

      {/* for mobile view. */}
      <div className=' lg:hidden block z-50 text-white  w-full  '>
        <div className='relative z-50 flex  items-center justify-between pr-2 bg-gradient-to-r bg-[#424242]'>
          <ToggleButton
            value={toggleBtnChecked}
            showAside={showAside}
            eventHandle={ToggleEventHandler}
          />

          {/* <img
            className="rounded-full absolute left-[44%] top-[10px] w-[65px] h-[65px]"
            src={logo}
            alt="logo"
          /> */}

          {GetLocalStorageUserId() ? (
            <button onClick={logoutHandle} className=''>
              Logout
            </button>
          ) : (
            <Link to={'/login'}>Login</Link>
          )}

          {/* <button className="">
            <Link to={"/login"}>Login</Link>
          </button> */}
        </div>

        <div
          className={`w-full bg-[#424242]   duration-300  absolute  z-40 ${
            showAside ? 'translate-y-0' : '-translate-y-[2000px]'
          }`}
        >
          <ul className='flex flex-col pb-4 gap-y-3 justify-center text-[18px] font-normal items-start pl-[40px]'>
            {Routes}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AsideNav;
